import React from 'react';
import '../../styles/About.css'
import { Link } from 'react-router-dom';
import { FaLinkedin, FaUserTie } from 'react-icons/fa';

export default function Board() {
    // Top Leadership (Chairman and Vice Chairman only)
    const topLeadership = [
        {
            id: 1,
            name: "Delreo Newman",
            role: "Chairman",
            subrole: "Executive Director of International Regulatory and Government Affairs, ATNI",
            image: process.env.PUBLIC_URL + '/assets/board/Delreo_Newman.JPG',
            link: 'https://www.linkedin.com/in/dr-delreo-newman-28473a1/',
        },
        {
            id: 2,
            name: "Charles Douglas",
            role: "Vice Chairman",
            subrole: "Director of Regulatory Affairs, Liberty Caribbean, Grenada",
            image: process.env.PUBLIC_URL + '/assets/board/Douglas.png',
            link: 'https://www.linkedin.com/in/charles-a-douglas-998889220/',
        },
    ];

    // Other Executive Members (Secretary General, Board Members)
    const otherExecutives = [
        
    ];

    // Directors
    const directors = [
        {
            id: 3,
            name: "Teresa Wankin",
            role: "Secretary General",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/board/Teresa_Wankin.JPG',
            link: 'https://www.linkedin.com/in/teresa-wankin-59a2b155/',
        },
        {
            id: 4,
            name: "John Gomez",
            role: "Treasurer",
            subrole: "CEO, Be ALIV Bahamas",
            image: process.env.PUBLIC_URL + '/assets/board/Gomez.png',
            link: 'https://www.linkedin.com/in/john-gomez-83b6b37b/',
        },
        {
            id: 5,
            name: "Desha Clifford",
            role: "Director",
            subrole: "Group Head of Regulatory Affairs, Digicel TCI",
            image: process.env.PUBLIC_URL + '/assets/board/Desha_Clifford.jpg',
            link: 'https://www.linkedin.com/in/deshaclifford/',
        },
        {
            id: 6,
            name: "Mark Reynolds",
            role: "Director",
            subrole: "General Counsel, WestTel Limited",
            image: process.env.PUBLIC_URL + '/assets/board/Mark.png',
            link: 'https://www.linkedin.com/in/mark-reynolds-8b2a2156/',
        },
        {
            id: 7,
            name: "Dickson Osuala",
            role: "Director",
            subrole: "Group Head of Regulatory Affairs, Digicel Trinidad and Tobago",
            image: process.env.PUBLIC_URL + '/assets/board/Dickson.png',
            link: 'https://www.linkedin.com/in/dickson-c-t-osuala-phd-68785331/',
        },
        {
            id: 8,
            name: "Rhys Campbell",
            role: "Director",
            subrole: "Head of Liberty Caribbean Foundation and ESG, Liberty Caribbean",
            image: process.env.PUBLIC_URL + '/assets/board/Rhys.png',
            link: 'https://www.linkedin.com/in/rhys-d-campbell-3836b883/',
        },
        {
            id: 9,
            name: "Vaughn Brown",
            role: "Director",
            subrole: "Telecoms Business Unit Manager, Antigua Public Utilities Authority (APUA)",
            image: process.env.PUBLIC_URL + '/assets/board/Vaughn.png',
            link: '',
        },
        {
            id: 10,
            name: "Rattan Boodram",
            role: "Director",
            subrole: "Vice President, Technology, TSTT",
            image: process.env.PUBLIC_URL + '/assets/board/Rattan_Boodram.jpeg',
            link: 'https://www.linkedin.com/in/rattan-boodram-9280326/',
        },
    ];

    const renderMemberCard = (member, isExecutive = false) => {
        const hasLink = member.link && member.link.trim() !== '';
        const CardWrapper = hasLink ? Link : 'div';
        const cardProps = hasLink 
            ? { to: member.link, target: '_blank', className: `board-member-card ${isExecutive ? 'executive' : ''}` }
            : { className: `board-member-card ${isExecutive ? 'executive' : ''}` };

        return (
            <CardWrapper key={member.id} {...cardProps}>
                {member.image ? (
                    <div 
                        className='board-member-photo-new' 
                        style={{
                            backgroundImage: `url(${member.image})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center top',
                        }}
                    />
                ) : (
                    <div className='board-member-photo-placeholder'>
                        <FaUserTie size={60} color='#282C68' />
                    </div>
                )}
                
                <div className='board-member-info'>
                    <div className='board-member-name'>
                        {member.name}
                        {hasLink && <FaLinkedin size={16} color='#0072b1' style={{marginLeft: '8px', flexShrink: 0}}/>}
                    </div>
                    <div className='board-member-role'>{member.role}</div>
                    {member.subrole && <div className='board-member-org'>{member.subrole}</div>}
                </div>
            </CardWrapper>
        );
    };

    return (
        <div className='board-page'>
            {/* Header Section */}
            <div className='board-hero'>
                <div className='board-hero-content'>
                    <h1 className='board-hero-title'>Board of Directors</h1>
                    <p className='board-hero-subtitle'>2026/2027</p>
                </div>
            </div>

            {/* Top Leadership Section - Chairman & Vice Chairman */}
            <div className='board-section'>
                <h2 className='board-section-title'>Executive Leadership</h2>
                <div className='board-section-divider'></div>
                <div className='board-grid top-leadership-grid'>
                    {topLeadership.map(member => renderMemberCard(member, true))}
                </div>
                <div className='board-grid other-executives-grid'>
                    {otherExecutives.map(member => renderMemberCard(member, true))}
                </div>
            </div>

            {/* Directors Section */}
            <div className='board-section directors-section'>
                {/* <h2 className='board-section-title'>Directors</h2> */}
                <div className='board-section-divider'></div>
                <div className='board-grid directors-grid'>
                    {directors.map(member => renderMemberCard(member, false))}
                </div>
            </div>
        </div>
    );
}
